<template>
  <div
    class="avator c:row-center c:flex-nowrap"
    :class="{ 'with-border': isManager, 'is-single': avatorChars.length === 1 }"
  >
    {{ avatorChars.value }}
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    isManager: Boolean,
  },
  computed: {
    avatorChars() {
      const [fn, ln] = this.name
        .trim()
        .split(/\s+/)
        .map((name) => name.slice(0, 1).toUpperCase());
      if (ln) {
        return {
          length: 2,
          value: [fn, ln].join(""),
        };
      }
      return {
        length: 1,
        value: fn,
      };
    },
  },
  mounted() {
    console.log("mounted");
  },
};
</script>

<style lang="less" scoped>
.avator {
  box-sizing: border-box;
  width: 46/20rem;
  height: 46/20rem;
  border-radius: 50%;
  margin-right: 14/20rem;
  background-color: #eee;

  font-weight: 600;
  font-size: 14/20rem;
  letter-spacing: 0;
  color: #b4b4b4;

  &.with-border {
    width: 44/20rem;
    height: 44/20rem;
  }

  &.is-single {
    font-weight: 500;
    font-size: 18/20rem;
  }
}
</style>
